import { IClient } from '../interfaces';

export interface IClientsState {
    clients: IClient[];
}

export const initialClientsState: IClientsState = {
    clients: undefined,
};
